// Nøkkelord-varsler på scraping-/OSINT-strømmer. En vaktliste av begreper
// (delstreng / helt ord / regex) matches mot innkommende tekstelementer (SoMe,
// nyhets-scrape, radio-transkript), og treff blir `Alert` (kind 'keyword') i
// samme prioriterte kø som resten. Ren + testbar; ingen nettverk her (scraping
// skjer i innsamlingslaget — ALDRI fra gradert nett, jf. OPSEC/grunnlov).
import { z } from 'zod';
export const WatchMode = z.enum(['substring', 'word', 'regex']);
export const WatchTermSchema = z.object({
    id: z.string().min(1),
    term: z.string().min(1),
    mode: WatchMode.default('substring'),
    severity: z.enum(['info', 'advarsel', 'kritisk']).default('advarsel'),
    caseSensitive: z.boolean().default(false),
});
function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
/** Kompiler vaktliste til regexer. Ugyldig regex-term hoppes over (aldri crash). */
export function compileWatch(terms) {
    const out = [];
    for (const raw of terms) {
        const t = WatchTermSchema.parse(raw);
        const flags = t.caseSensitive ? 'g' : 'gi';
        let pattern;
        if (t.mode === 'regex')
            pattern = t.term;
        else if (t.mode === 'word')
            pattern = `\\b${escapeRegExp(t.term)}\\b`;
        else
            pattern = escapeRegExp(t.term);
        try {
            out.push({ term: t, re: new RegExp(pattern, flags) });
        }
        catch { /* ugyldig regex ignoreres */ }
    }
    return out;
}
/** Kort utdrag rundt første treff (til varsel-detalj). */
function excerptAround(text, index, len, radius = 30) {
    const start = Math.max(0, index - radius);
    const end = Math.min(text.length, index + len + radius);
    return (start > 0 ? '…' : '') + text.slice(start, end).trim() + (end < text.length ? '…' : '');
}
/** Finn alle vaktliste-treff i én tekst (ett treff per term). */
export function scanText(text, compiled) {
    const out = [];
    for (const c of compiled) {
        c.re.lastIndex = 0;
        const m = c.re.exec(text);
        if (m) {
            out.push({ termId: c.term.id, term: c.term.term, severity: c.term.severity,
                excerpt: excerptAround(text, m.index, m[0].length) });
        }
    }
    return out;
}
/** Skann en strøm av tekstelementer mot vaktlista → Alert[] (kind 'keyword'). */
export function keywordAlerts(items, terms) {
    const compiled = compileWatch(terms);
    if (!compiled.length)
        return [];
    const out = [];
    for (const it of items) {
        for (const hit of scanText(it.text, compiled)) {
            out.push({
                key: `kw:${hit.termId}:${it.id}`, kind: 'keyword', severity: hit.severity,
                refId: it.id, tsMs: it.tsMs,
                title: `Nøkkelord «${hit.term}»${it.source ? ' i ' + it.source : ''}`,
                detail: hit.excerpt,
            });
        }
    }
    return out;
}
//# sourceMappingURL=keywordwatch.js.map